import * as THREE from 'three'

/**
 * 带 `firstHitOnly` 扩展字段的 Raycaster。
 */
type BvhReadyRaycaster = THREE.Raycaster & {
  firstHitOnly?: boolean
}

/**
 * 配置 Raycaster 是否只返回最近命中。
 *
 * 设计说明：
 * 1. `three-mesh-bvh` 在 `firstHitOnly=true` 时会走更快的 `raycastFirst` 分支；
 * 2. 该配置只应应用到“业务本身只消费最近命中”的链路，避免影响依赖完整命中列表的交互逻辑；
 * 3. 这里单独收口为底层函数，避免业务模块直接感知第三方库扩展字段。
 *
 * @param raycaster 目标射线器。
 * @param enabled 是否启用只取最近命中。
 * @returns 原射线器，便于链式复用。
 */
export function setRaycasterFirstHitOnly<TRaycaster extends THREE.Raycaster>(
  raycaster: TRaycaster,
  enabled = true,
): TRaycaster {
  (raycaster as BvhReadyRaycaster).firstHitOnly = enabled
  return raycaster
}
